<ng-container *ngIf="files">
  <ng-container *ngIf="!files.current.length && !files.toUpload.length">{{ emptyText | capitalize }}</ng-container>
  <div *ngIf="photoMode">
    <ng-container *ngFor="let file of files.current">
      <app-image-preview-item [colors]="colors" [photoPath]="file.storagePath"></app-image-preview-item>
    </ng-container>
    <ng-container *ngFor="let file of files.toUpload">
      <app-image-preview-item [colors]="colors" [rawData]="file.rawData"></app-image-preview-item>
    </ng-container>
  </div>
  <div *ngIf="!photoMode">
    <app-attachment-list-in-form [structList]="files.current" [disabled]="true"></app-attachment-list-in-form>
    <app-attachment-list-in-form [fileList]="files.toUpload" [showNewText]="true" [disabled]="true"></app-attachment-list-in-form>
  </div>
</ng-container>
